import React, {createContext, useCallback, useContext, useState} from "react";
import {mapCoursesData} from "./course.data.service";
import * as Yup from "yup";
import {Formik} from "formik";
import {toast} from "react-toastify";
import {fetchCourseListDetails} from "./course.api.service";
import HttpService from "../../../services/HttpService";


const CoursesContext = createContext();

export function useCoursesContext() {
    return useContext(CoursesContext)
}

const validationSchema = Yup.object().shape({
    data: Yup.array().of(
        Yup.object().shape({
            course_name: Yup.string().required('Required'),
            golfcourseholes: Yup.number().positive().required('Required').nullable(),
        })
    )
})


export const CoursesProvider = ({children}) => {

    // These values would get updated using formik
    const [initialState, setInitialState] = useState({
        data: [],
        activeCourseIndex: 0,
        loading: false,
        saving: false,
        deleting: false,
        clicking: false
    });

    const [fetching, setFetching] = useState(false)


  const fetchCourses = useCallback(async (location, activeCourseIndex) => {
    try {
        setInitialState(_s => ({
            ..._s,
            loading: true
        }));

        const role = (localStorage.getItem("userRole") || "").toLowerCase();
        const isSuperAdmin = role === "superadmin";

        let res;
        if (isSuperAdmin) {
            const clubId = localStorage.getItem("selected_club_id");
            res = await HttpService.get(`/club/golf-course-details-admin/?club_id=${clubId}`);
        } else {
            res = await fetchCourseListDetails(); 
        }

        const _coursesList = mapCoursesData(res.data.data);

        if (location.index) {
            setInitialState(_s => ({
                ..._s,
                data: _coursesList,
                activeCourseIndex: _coursesList.length ? location.index : null
            }));
        } else {
            setInitialState(_s => ({
                ..._s,
                data: _coursesList,
                activeCourseIndex: _s.activeCourseIndex === null ? activeCourseIndex : _s.activeCourseIndex
            }));
        }

    } catch (e) {
        toast.error("Failed to load courses");
    } finally {
        setInitialState(_s => ({
            ..._s,
            loading: false
        }));
    }
}, []);


    const deleteCourse = async (courseId) => {
        try {

            setInitialState(_s => ({
                ..._s,
                deleting: true
            }))

            const res = await HttpService.delete(
                `/club/course/`,
                {
                    data: {
                        "golf_course_id": 199
                    }
                },
            )


        } catch (e) {
            toast.error('Unable to delete course!')
        } finally {
            setInitialState(_s => ({
                ..._s,
                deleting: false
            }))
        }
    }


   const updateCourses = async (course, silentUpdate = false) => {
    try {
        if (!silentUpdate) {
            setInitialState(_s => ({
                ..._s,
                saving: true
            }))
        }

        const role = (localStorage.getItem("userRole") || "").toLowerCase();
        const isSuperAdmin = role === "superadmin";
            const clubId = localStorage.getItem("selected_club_id");

        const url = isSuperAdmin
            ? `/club/golf-course-update/${course.id}/`
            : `/club/course_details/${course.id}/`;

        const res = await HttpService.put(url, course);

        if (res.status === 200 && !silentUpdate) {
            toast.success("Course updated successfully");
        }

    } catch (e) {
        if (!silentUpdate) toast.error('Unable to update course!');
    } finally {
        if (!silentUpdate) {
            setInitialState(_s => ({
                ..._s,
                saving: false
            }))
        }
    }
}

const createCourse = async (course) => {
    try {
        setInitialState(_s => ({
            ..._s,
            saving: true
        }))

        const role = (localStorage.getItem("userRole") || "").toLowerCase();
        const isSuperAdmin = role === "superadmin";

        const url = isSuperAdmin
            ? `/club/superadmin/course_details/`
            : `/club/course_details/`;

        const res = await HttpService.post(url, course);

        if (res.status === 201) {
            toast.success("Course created successfully");
        }

    } catch (e) {
        toast.error('Unable to create course!');
    } finally {
        setInitialState(_s => ({
            ..._s,
            saving: false
        }))
    }
}



    const onSubmit = (formik, silentUpdate = false) => {
        // Submit all the courses details to server
        const {values} = formik
        const {activeCourseIndex, data} = values
        // debugger
        if (activeCourseIndex === null) return


        const courseData = data[activeCourseIndex]

        if (courseData.id) {
            // updating the existing courses
            updateCourses(courseData, silentUpdate).then(() => fetchCourses(0, activeCourseIndex));
        } else {
            // creating a new course
            createCourse(courseData)
        }


    }

    const onClickScroll = (index) => {
        setInitialState(_s => ({
            ..._s,
            activeCourseIndex: index,
            clicking: !(initialState.clicking)
        }))
    }


    return (
        <CoursesContext.Provider
            value={{
                // actions
                fetchCourses,
                deleteCourse,
                // onAdd,
                // onRemove,
                onClickScroll,
                onSubmit,

                // loader
                fetching,
            }}
        >
            <Formik
                initialValues={initialState}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {children}
            </Formik>
        </CoursesContext.Provider>
    )


}
